import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-valetsurvey',
    templateUrl: './valetsurvey.component.html',
    styleUrls: ['./valetsurvey.component.scss'],
    standalone: false
})
export class ValetSurveyComponent extends Busyable implements OnInit {
  public ModelId: any;
  public Model: any;

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, public router: Router) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("valet/surveys/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    });
  }
}
